// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1z0E-","col":"styles_col__VPpbv"};